import {BringozMenuItem} from "../../../commons/angular/components/bringoz-menu-panel/bringoz-menu-panel.component";

export const PLANNING_DRAFT_JOB_MENU_ITEMS: Readonly<Record<
  'createRoute' | 'assignToRoute' | 'addToDraft' | 'moveToLeftovers' | 'lock' | 'unlock' | 'removeFromDraft',
  Omit<BringozMenuItem, 'disabled'>
>> = {
  createRoute: {
    name: 'Create A Route',
    action: 'createRoute',
    iconName: 'route',
  },
  assignToRoute: {
    name: 'Assign On A Route',
    action: 'assignToRoute',
    iconName: 'assign',
  },
  addToDraft: {
    name: 'Add To Draft',
    action: 'addToDraft',
    iconName: 'plus-circle',
  },
  moveToLeftovers: {
    name: 'Move To Leftovers',
    action: 'moveToLeftovers',
    iconName: 'leftover',
  },
  lock: {
    name: 'Lock',
    action: 'toggleLock',
    iconName: 'lock',
  },
  unlock: {
    name: 'Unlock',
    action: 'toggleLock',
    iconName: 'lock-open-outline',
  },
  removeFromDraft: {
    name: 'Remove From Draft',
    action: 'removeFromDraft',
    iconName: 'trash',
  },
};
